import React from "react";
import { HomeView } from "../components/HomeView";
import { ValuesFooter } from "../components/ValuesFooter";

export function HomeRoute({ topics, heroAd, onSwapHero, onSelectTopic }) {
  return (
    <>
      <main className="max-w-[1600px] w-full mx-auto px-4 md:px-6 py-4">
        <HomeView
          topics={topics}
          heroCampaign={heroAd}
          onSwapHero={onSwapHero}
          onSelectTopic={onSelectTopic}
        />
      </main>
      <ValuesFooter />
    </>
  );
}
